const navLinks = [
    {
        name: 'Главная',
        href: '/'
    },
    {
        name: 'Каталог',
        href: '/'
    },
    {
        name: 'Кофейня',
        href: '/cafeteria'
    },
    {
        name: 'Акции',
        href: '#'
    },
    {
        name: 'Контакты',
        href: '#'
    }
];

export default navLinks;
